import { getContext } from '@/context';

export const GENAI_STUDIO_TOUCHPOINT = 'com.picsart.apps.genai';

/** Web entry whose URL contains the /genaistudio path segment. */
export const isWebGenaiStudio = (): boolean => {
  if (typeof window === 'undefined') return false;
  return /genaistudio/i.test(window.location.href);
};

/** SDK location route contains the gen-ai segment (editor host's gen-ai section). */
export const isGenaiRoute = (): boolean => {
  try {
    const route = getContext().general.location.getState?.()?.route ?? '';
    // eslint-disable-next-line no-restricted-syntax -- canonical source of the surface check; callers use this predicate
    return route.includes('gen-ai');
  } catch {
    return false;
  }
};
